import * as React from 'react';
import classnames from 'classnames';

import '../../header/tile-standard-header.scss';
import '../../header/avatar/tile-standard-header-avatar.scss';
import '../../header/details/tile-standard-header-details.scss';
import '../../header/details/artist-name/tile-standard-header-details-artist-name.scss';
import '../../header/details/section/tile-standard-header-details-section.scss';
import './tile-standard-loading-header.scss';

const TileStandardLoadingHeader = (): JSX.Element => {
  const renderSection = (index: number): JSX.Element => {
    const labelClasses = classnames('tile-standard-header-details-section__label',
      'tile-standard-loading-header-details-section__label', {
        [`tile-standard-loading-header-details-section__label--${index}`]: index >= 0
      }
    );

    const valueClasses = classnames('tile-standard-header-details-section__value',
      'tile-standard-loading-header-details-section__value', {
        [`tile-standard-loading-header-details-section__value--${index}`]: index >= 0
      }
    );

    return (
      <div
        key={`tile-standard-header-details-section--${index}`}
        className="tile-standard-header-details-section"
      >
        <div className={labelClasses} />
        <div className={valueClasses} />
      </div>
    );
  };

  return (
    <div className="tile-standard-header tile-standard-loading-header">
      <div className="tile-standard-header__avatar">
        <div className="tile-standard-header-avatar tile-standard-loading-header-avatar" />
      </div>
      <div className="tile-standard-header-details tile-standard-loading-header-details">
        <div className="tile-standard-header-details-artist-name">
          <div className="tile-standard-loading-header-details-artist-name" />
        </div>
        <div className="tile-standard-header-details__info">
          {[0, 1, 2, 3, 4].map(renderSection)}
        </div>
      </div>
    </div>
  );
};

export default TileStandardLoadingHeader;
